<template>
  <v-card width="420px" max-height="560px">
    <v-toolbar card dense color="blue darken-4">
      <v-toolbar-title>
        <h5 style="color:white;">Notifications</h5>
      </v-toolbar-title>
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
        style="margin-left: -20px;"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="clearNotificationAll">
              <v-icon size="22" style="color: #757575;">delete</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Remove all</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      <!-- <v-tooltip bottom>
        <v-btn flat icon small  slot="activator"  style="outline: none;"  @click="clearNoti">
          <v-icon>delete</v-icon>
        </v-btn>
        <span>Mark read all</span>
      </v-tooltip> -->
    </v-toolbar>
    <!-- <v-flex v-if="items.length != 0" class="btn-clear" @click="clearNotificationAll">
      <span>Delete all notification</span>
    </v-flex> -->
    <!-- <v-divider></v-divider> -->
    <v-card-text class="pa-0">
      <v-list two-line>
        <v-flex v-if="loading" my-4>
          <v-progress-circular
            :width="3"
            color="blue darken-1"
            xs-12
            indeterminate
          />
        </v-flex>
        <v-flex v-else-if="items.length == 0" >
          <v-list-tile v-if="items.length == 0 && newrelease" :key="index" style="background-color: #EAF1FF;"  @click="redirect()">
            <v-list-tile-content style="max-width: 35px;">
              <v-icon color="#558B2F" style="position: absolute; top: 19px;">new_releases</v-icon>
              <v-flex class="tag" style="color: #558B2F; left: 12px;">Update</v-flex>
            </v-list-tile-content>
            <v-list-tile-content>
              <v-list-tile-title>iLog v2.6 New Release</v-list-tile-title>
              <v-list-tile-sub-title>New Layout, PDPA module, Alert history ...</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <span v-else>No notifications</span>
        </v-flex>
        <template v-else v-for="(item, index) in items">
          <!-- new release notification -->
          <v-list-tile v-if="index === 0 && newrelease" :key="index" style="background-color: #EAF1FF;"  @click="redirect()">
            <v-list-tile-content style="max-width: 35px;">
              <v-icon color="#558B2F" style="position: absolute; top: 19px;">new_releases</v-icon>
              <v-flex class="tag" style="color: #558B2F; left: 12px;">Update</v-flex>
            </v-list-tile-content>
            <v-list-tile-content>
              <v-list-tile-title>iLog v2.6 New Release</v-list-tile-title>
              <v-list-tile-sub-title>New Layout, PDPA module, Alert history ...</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- END -->
          <v-list-tile
            :key="item._id"
            avatar
            :style="!item.read? 'background-color: #EAF1FF;':'background-color: #FFFFFF;'"
            @click="toAlert(item)"
          >
            <v-list-tile-content style="max-width: 35px;">
              <v-icon color="#C65F00">warning</v-icon>
              <v-flex v-if="item.type === 'tcca'" class="tag">TCCA</v-flex>
              <v-flex v-else-if="item.type === 'pdpa'" class="tag">PDPA</v-flex>
              <v-flex v-else-if="item.type === 'set'" class="tag" style="margin-left: 4px;">SET</v-flex>
              <v-flex v-else-if="item.type === 'at'" class="tag" style="left: 23px;">AT</v-flex>
            </v-list-tile-content>
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title>{{item.description}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon style="outline:none !important;" @click="deleteNoti(item)">
                <v-icon color="grey lighten-1" size="20">clear</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-divider v-if="!btn_disable && items.length != 0" />
      <v-flex row mx-3 v-if="!btn_disable && items.length != 0">
        <button @click="clearNoti" class="btn-mark-all font-weight-regular">
          <span>Mark all as read</span>
        </button>
        <v-spacer />
        <button @click="seemore" class="btn-see-more font-weight-regular">
          <span>See more...</span>
        </button>
      </v-flex>
        <!-- <v-btn
            v-if="!btn_disable && items.length != 0"
            round
            depressed
            flat
            color="blue lighten-2"
            @click="seemore"
            style="text-transform: capitalize; outline:none !important;"
            class="font-weight-normal">
            <span>see more ...</span>
        </v-btn> -->
    </v-card-text>
  </v-card>
</template>
<script>
import axios from 'axios'
export default {
  name: 'notification',
  props: {
    name: {
      type: Array
    }
  },
  data () {
    return {
      items: [],
      count: 3,
      btn_disable: false,
      loading: true,
      newrelease: false
    }
  },
  created () {
    // แสดง new release จนถึงสิ้นปี 2021
    let dateTime = new Date()
    if (dateTime.getMonth() + 1 <= 12 && dateTime.getFullYear() === 2021) {
      this.newrelease = true
    }
  },
  methods: {
    async clearNoti () {
      this.items.map(el => {
        el.read = true
      })
      this.$emit('clearNoti')
    },
    clearNotificationAll () {
      this.items = []
      this.$emit('delNoticAll')
    },
    async deleteNoti (item) {
      this.$emit('delNoti')
      this.items = this.items.filter(el => el._id !== item._id)
      await axios.post(apiUrl + '/api/query/notification', {
        id: item._id,
        command: 'deleteone'
      })
      if (this.items.length === 0) {
        if (this.btn_disable) {
          this.$emit('seemore')
        } else {
          this.$emit('reload')
        }
      }
    },
    seemore () {
      this.btn_disable = true
      this.$emit('seemore')
    },
    async toAlert (e) {
      await axios.post(apiUrl + '/api/query/notification', {
        id: e._id,
        command: 'readone'
      })
      this.items.map(el => {
        if (el._id === e._id) {
          el.read = true
        }
      })
      this.$emit('delNoti')
      let dataDateTime = new Date(e.createdate)
      let dateTimeST = new Date(dataDateTime.getFullYear(), dataDateTime.getMonth() + 1, dataDateTime.getDate(), dataDateTime.getHours(), dataDateTime.getMinutes() - 1, 0)
      let dateTimeEND = new Date(dataDateTime.getFullYear(), dataDateTime.getMonth() + 1, dataDateTime.getDate(), dataDateTime.getHours(), dataDateTime.getMinutes(), 0)
      // let newDateST = new Date(dataDateTime.getFullYear(), dataDateTime.getMonth(), dataDateTime.getDate(), dataDateTime.getHours(), dataDateTime.getMinutes() - 5, dataDateTime.getSeconds())
      // let newDateEND = new Date(dataDateTime.getFullYear(), dataDateTime.getMonth(), dataDateTime.getDate(), dataDateTime.getHours(), dataDateTime.getMinutes(), dataDateTime.getSeconds())
      let MonthST = ''
      let MonthEND = ''
      let dayST = ''
      let dayEND = ''
      let hourST = ''
      let hourEND = ''
      let minuteST = ''
      let minuteEND = ''
      if (dateTimeST.getMonth() < 10) {
        MonthST = `0${dateTimeST.getMonth()}`
      } else {
        MonthST = dateTimeST.getMonth()
      }
      if (dateTimeEND.getMonth() < 10) {
        MonthEND = `0${dateTimeEND.getMonth()}`
      } else {
        MonthEND = dateTimeEND.getMonth()
      }
      if (dateTimeST.getDate() < 10) {
        dayST = `0${dateTimeST.getDate()}`
      } else {
        dayST = dateTimeST.getDate()
      }
      if (dateTimeEND.getDate() < 10) {
        dayEND = `0${dateTimeEND.getDate()}`
      } else {
        dayEND = dateTimeEND.getDate()
      }
      if (dateTimeST.getHours() < 10) {
        hourST = `0${dateTimeST.getHours()}`
      } else {
        hourST = dateTimeST.getHours()
      }
      if (dateTimeEND.getHours() < 10) {
        hourEND = `0${dateTimeEND.getHours()}`
      } else {
        hourEND = dateTimeEND.getHours()
      }
      if (dateTimeST.getMinutes() < 10) {
        minuteST = `0${dateTimeST.getMinutes()}`
      } else {
        minuteST = dateTimeST.getMinutes()
      }
      if (dateTimeEND.getMinutes() < 10) {
        minuteEND = `0${dateTimeEND.getMinutes()}`
      } else {
        minuteEND = dateTimeEND.getMinutes()
      }
      let newDateST = `${dateTimeST.getFullYear()}-${MonthST}-${dayST}T${hourST}:${minuteST}:10`
      let newDateEND = `${dateTimeEND.getFullYear()}-${MonthEND}-${dayEND}T${hourEND}:${minuteEND}:10`
      if (e.type === 'tcca') {
        sessionStorage.setItem('iLog-search-alert', JSON.stringify({device: e.device, startdate: newDateST, enddate: newDateEND}))
        if (this.$router.history.current.name === 'alertHistorytcca') {
          this.$router.go()
        } else {
          this.$router.push({name: 'alertHistorytcca'})
        }
        // this.$router.push({name: 'alertHistorytcca'})
        this.$emit('setNev')
      } else if (e.type === 'pdpa') {
        sessionStorage.setItem('iLog-search-alert', JSON.stringify({ index: 0, device: e.device, startdate: newDateST, enddate: newDateEND }))
        if (this.$router.history.current.name === 'alertHistorypdpa') {
          this.$router.go()
        } else {
          this.$router.push({name: 'alertHistorypdpa'})
        }
        // this.$router.push({name: 'alertHistorypdpa'})
        this.$emit('setNev')
      } else if (e.type === 'at') {
        sessionStorage.setItem('iLog-search-alert', JSON.stringify({ index: 1, device: e.device, startdate: newDateST, enddate: newDateEND }))
        if (this.$router.history.current.name === 'alertHistorypdpa') {
          this.$router.go()
        } else {
          this.$router.push({name: 'alertHistorypdpa'})
        }
        // this.$router.push({name: 'alertHistorypdpa'})
        this.$emit('setNev')
      } else {
        if (this.$router.history.current.name === 'alert') {
          this.$router.go()
        } else {
          this.$router.push({name: 'alert'})
        }
        // this.$router.push({name: 'alert'})
        this.$emit('setNev')
      }
    },
    redirect () {
        window.open('https://docs.ilog.ai/ilog-v2-6-new-release/', '_blank')
    }
  },
  watch: {
    name: function () {
      this.btn_disable = false
      this.items = this.name
      // this.btn_disable = false
      setTimeout(() => {
        if (this.items.length >= 6) {
          this.btn_disable = true
        }
      }, 500)

      if (this.items.length > 0) {
        this.loading = false
      } else {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 3500)
      }
      // if (this.items.length <= 6) {
      //   this.btn_disable = true
      // }
    }
  }
}
</script>

<style scoped>
.btn-clear {
  position: absolute;
  right: 20px;
  top: 46px;
  text-align-last: right;
  font-size: 12px;
  cursor: pointer;
  /* color: #26A69A; */
  color: #00B0FF;
}
.btn-mark-all {
  text-decoration-line: underline;
  font-size: 13px ;
  text-transform: none;
  color: #212121;
  outline: none;
  margin-bottom: 10px;
}
.btn-see-more {
  font-size: 13px ;
  text-transform: none;
  color: #212121;
  outline: none;
  margin-bottom: 10px;
}
.tag {
  position: absolute;
  bottom: 13px;
  margin: 0 auto;
  text-transform: none;
  color: #E65100;
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/notification.vue